import { reasonToDescription } from "@atoms/atom-types";
import type { CSSProperties } from "react";
import type { NoAccessScreenProps } from "../FrontendProvision";

export function DefaultNoAccessScreen({
  reason,
  detail,
  statusCode,
  onRetry,
  onSignOut,
}: Readonly<NoAccessScreenProps>) {
  const message = reasonToDescription[reason] ?? reasonToDescription.unknown;

  const buttonBase: CSSProperties = {
    font: "inherit",
    fontSize: "14px",
    lineHeight: 1.25,
    padding: "10px 18px",
    borderRadius: "8px",
    cursor: "pointer",
    border: "1px solid #d1d5db",
    background: "#fff",
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        boxSizing: "border-box",
        background: "#f9fafb",
      }}
    >
      <div
        style={{
          maxWidth: "560px",
          width: "100%",
          textAlign: "center",
          padding: "32px 28px",
          borderRadius: "12px",
          border: "1px solid #e5e7eb",
          background: "#fff",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        }}
      >
        <h1
          style={{
            margin: "0 0 12px",
            fontSize: "1.5rem",
            fontWeight: 600,
          }}
        >
          Kein Zugriff auf diese Anwendung
        </h1>
        <p style={{ margin: "0 0 8px", color: "#374151" }}>{message}</p>
        {statusCode ? (
          <p style={{ margin: "0", color: "#6b7280", fontSize: "14px" }}>
            Status: {statusCode}
          </p>
        ) : null}
        {detail ? (
          <p
            style={{
              marginTop: "16px",
              color: "#6b7280",
              fontSize: "14px",
              wordBreak: "break-word",
              textAlign: "left",
              fontFamily: "ui-monospace, monospace",
            }}
          >
            {detail}
          </p>
        ) : null}
        <div
          style={{
            marginTop: "24px",
            display: "flex",
            gap: "12px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            type="button"
            style={{
              ...buttonBase,
              border: "1px solid #2563eb",
              background: "#2563eb",
              color: "#fff",
            }}
            onClick={onRetry ?? (() => globalThis.location.reload())}
          >
            Erneut versuchen
          </button>
          {onSignOut ? (
            <button type="button" style={buttonBase} onClick={onSignOut}>
              Abmelden
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
